import { useEffect, useState } from 'react'

import type { UiColorMode } from 'src/design-system/ui/themes'

// Preserve the existing user's preference across Professional and legacy
// routes during retirement. The key is a stored preference, not MUI state.
export const PROFESSIONAL_MODE_KEY = 'mui-mode'
export const readProfessionalMode = (): UiColorMode => {
  try {
    const mode = localStorage.getItem(PROFESSIONAL_MODE_KEY)
    return mode === 'light' || mode === 'dark' ? mode : 'system'
  } catch {
    return 'system'
  }
}

export const useProfessionalMode = () => {
  const [mode, setMode] = useState(readProfessionalMode)
  useEffect(() => {
    const update = (event: StorageEvent) => {
      if (event.key === PROFESSIONAL_MODE_KEY || event.key === null)
        setMode(readProfessionalMode())
    }
    window.addEventListener('storage', update)
    return () => window.removeEventListener('storage', update)
  }, [])
  const chooseMode = (value: UiColorMode) => {
    setMode(value)
    try {
      localStorage.setItem(PROFESSIONAL_MODE_KEY, value)
    } catch {
      /* Selection still works without storage. */
    }
  }
  return { mode, chooseMode }
}
